const r = () => {
  var n;
  const l = [
    "de_DE",
    "en_US",
    "es_ES",
    "fr_FR",
    "it_IT",
    "ja_JP",
    "ko_KR",
    "nl_NL",
    "pl_PL",
    "pt_BR",
    "ru_RU",
    "tr_TR",
    "zh_CN",
    "zh_TW"
  ], e = (n = document.querySelector("html").getAttribute("lang")) == null ? void 0 : n.replace("-", "_");
  return e && l.includes(e) ? e : "en_US";
}, o = () => {
  const l = [
    "en_US",
    "de_DE",
    "es_ES",
    "fr_FR",
    "it_IT",
    "ja_JP",
    "ko_KR",
    "nl_NL",
    "pl_PL",
    "pt_BR",
    "ru_RU",
    "tr_TR",
    "zh_CN",
    "zh_TW"
  ], t = Array.from(document.querySelectorAll("html")).at(-1).getAttribute(
    "lang"
  );
  return t && l.includes(t) ? t : "en_US";
}, _ = () => {
  const l = {
    en_US: () => import("./index16.js").then(({ en_US: t }) => t),
    de_DE: () => import("./index17.js").then((t) => t.default),
    es_ES: () => import("./index18.js").then((t) => t.default),
    fr_FR: () => import("./index19.js").then((t) => t.default),
    it_IT: () => import("./index20.js").then((t) => t.default),
    ja_JP: () => import("./index21.js").then((t) => t.default),
    ko_KR: () => import("./index22.js").then((t) => t.default),
    nl_NL: () => import("./index23.js").then((t) => t.default),
    pl_PL: () => import("./index24.js").then((t) => t.default),
    pt_BR: () => import("./index25.js").then((t) => t.default),
    ru_RU: () => import("./index26.js").then((t) => t.default),
    tr_TR: () => import("./index27.js").then((t) => t.default),
    zh_CN: () => import("./index28.js").then((t) => t.default),
    zh_TW: () => import("./index29.js").then((t) => t.default)
  }, e = o();
  return l[e]();
};
export {
  _ as fetchStorybookFallback,
  r as getLocale,
  o as getStorybookLocale
};
